var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"expandable-row"},[_c('div',{staticClass:"expandable-row__icon",class:{ 'expandable-row__expanded': _vm.$parent.expandableItems[_vm.index] },on:{"click":function($event){return _vm.$parent.toggleExpandedRow(_vm.index)}}},[_c('i',{class:_vm.$parent.expandableItems[_vm.index] ? 'fa fa-caret-down' : 'fa fa-caret-right'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }